import { FC, useState } from "react";
import { Col, Row } from "antd";
import SavedSearch from "modules/Content/Search/Components/SavedSearch";
import AudienceSearchBar from "../Search/AudienceSearchBar";
import { TAB_AUDIENCE } from "constants/paths";
import { AudienceParams } from "./AudienceHeader";
import { useParams } from "react-router-dom";
import {
  resetAudienceListSearchTerm,
  resetAudiencePeopleSearchTerm,
  setAudienceListSearchTerm,
} from "../Lists/actions";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { AUDIENCE_LISTS_SEARCH } from "constants/types";
import styled from "styled-components";

interface IAudienceSearchTab {
  page?: string;
  isProfiled?: boolean;
  tabState?: string;
}

const AudienceSearchTab: FC<IAudienceSearchTab> = (props) => {
  const { page, tab } = useParams<AudienceParams>();

  // if Dashboard page show the save search button
  const isDashboard = page === undefined || page === "/";

  // if Details page
  const isDetails = tab === TAB_AUDIENCE.VIEW;
  const isList = page === TAB_AUDIENCE.LISTS;

  const searchTermReducer = useSelector((state: RootState) => state.audienceLists.searchTerm);
  const resetSearchCount = useSelector((state: RootState) => state.audienceLists.resetSearchCount);
  const searchTermPeople = useSelector((state: RootState) => state.peopleAudience.searchTermPeople);
  const searchTermListDetails = useSelector((state: RootState) => state.audienceListDetails.searchTermListDetails); // search term in list

  let searchTerm = "";

  const getPlaceholder = (value?: string) => {
    switch (value) {
      case TAB_AUDIENCE.ACCOUNTS:
        return "Search accounts and companies...";
      case TAB_AUDIENCE.LISTS:
        searchTerm = searchTermReducer;
        if (isDetails) return "Search contacts...";
        else return "Search lists...";
      case TAB_AUDIENCE.PEOPLE:
        searchTerm = "";
        return "Search contacts...";
      default:
        return "Search for accounts, companies or people...";
    }
  };

  const placeholder = getPlaceholder(page);

  const submitHandler = (value: any) => {
    if (isList && searchTermReducer !== value) {
      store.dispatch({
        type: AUDIENCE_LISTS_SEARCH.REFRESH_SEARCH,
        payload: value,
      });
      setAudienceListSearchTerm(value);
    }
  };
  const clearHandler = () => {
    if (isList) resetAudienceListSearchTerm();
    else resetAudiencePeopleSearchTerm(props.isProfiled);
  };

  return (
    <Wrapper>
      <Row gutter={24}>
        {isDashboard ? (
          <>
            <Col className="gutter-row" span="20">
              <AudienceSearchBar
                resetTerm={resetSearchCount}
                searchTerm={isList ? searchTermReducer : searchTermPeople}
                ShowRefreshIcon={true}
                Placeholder={placeholder}
                submitHandler={submitHandler}
                clearHandler={clearHandler}
                isList={isList}
              />
            </Col>
            <Col className="gutter-row" span="4">
              <SavedSearch />
            </Col>
          </>
        ) : isDetails ? (
          <Col className="gutter-row" span="24">
            <AudienceSearchBar
              resetTerm={resetSearchCount}
              searchTermListDetails={searchTermListDetails}
              ShowSearchIcon={false}
              ShowRefreshIcon={true}
              Placeholder={placeholder}
              showAdvance={false}
              isList={isList}
              isListDetials={true}
              submitHandler={submitHandler}
              clearHandler={clearHandler}
            />
          </Col>
        ) : (
          <Col className="gutter-row main-search" span="24">
            <AudienceSearchBar
              resetTerm={resetSearchCount}
              searchTerm={isList ? searchTermReducer : searchTermPeople}
              ShowSearchIcon={false}
              ShowRefreshIcon={true}
              Placeholder={placeholder}
              showAdvance={false}
              isList={isList}
              submitHandler={submitHandler}
              clearHandler={clearHandler}
            />
          </Col>
        )}
      </Row>
    </Wrapper>
  );
};

export default AudienceSearchTab;

const Wrapper = styled.div`
  .main-search .search-wraper .search-bar {
    width: 100%;
  }
`;
